module.exports = __webpack_public_path__ + "img/ercode_yn.60193653.png";